import React from 'react'
import {
  Switch,
  Route,
} from 'react-router-dom'
import {
  AppearContainer,
  ConfigurationOptions,
  ConfigurationRoot,
  NotFound,
} from '../../'

const Configuration = (props) => {
  const {
    currentPath,
  } = props

  return (
    <AppearContainer transitionKey={currentPath.join()}>
      <Switch>
        <Route
          exact
          path="/konfiguration"
          component={ConfigurationRoot}
        />
        <Route
          path="/konfiguration/:id"
          component={ConfigurationOptions}
        />
        <Route component={NotFound} />
      </Switch>
    </AppearContainer>
  )
}

export default Configuration



// WEBPACK FOOTER //
// ./src/modules/configuration/components/configuration.jsx